/**
 *
 * @module entry
 * @desc {SDK.Paywall} entry point.
 *
 */

import PaywallApi from './paywallApi';
import PaywallManager from './paywallManager';

/**
 *
 * @typedef SDK.Paywall
 * @type {Object}
 *
 * @property {PaywallApi} PaywallApi
 * @property {PaywallManager} PaywallManager
 *
 */

/**
 *
 * @type {SDK.Paywall}
 *
 */
export default {

    PaywallApi,
    PaywallManager

};



// WEBPACK FOOTER //
// ./src/paywall/entry.js